import * as UAParser from "ua-parser-js";
import { generateGUID } from "./utils";
import { ETHERNET_PRODUCT_STRING } from "../assets/const/eventConstants";

export const getPageLoadtime = () => {
  const navigationEntry = performance.getEntriesByType(
    "navigation"
  )[0];
  if (navigationEntry) {
    const pageLoadTime =
      navigationEntry.domContentLoadedEventEnd - navigationEntry.startTime;
    return pageLoadTime > 0 ? pageLoadTime : undefined;
  }
  return 0;
};

// get browser and os details
export const getBrowserAndOS = () => {
  const parser = new UAParser.UAParser();
  const browser = parser.getBrowser();
  const os = parser.getOS();

  return {
    browser: browser.name || "Unknown",
    browserVersion: browser.version || "Unknown",
    os: os.name || "Unknown",
  };
};

export const getVenueDetailsFromUrl = () => {
  const pathSegmentWithoutHash = window.location.hash.split('#').filter(Boolean)[0];
  const venueId = pathSegmentWithoutHash?.split('/').filter(Boolean)[0] || "";
  const path = pathSegmentWithoutHash?.split("/").filter(Boolean).pop() || "";
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

  // If there are 3 or more host parts, the first part is likely the subdomain
  const subdomain =
    hostname.split(".").length >= 3 && !isLocalhost
      ? hostname.split(".")[0]
      : "";

  return { venueId, path, subdomain };
};

export const getCombinedUrlSearchParams = () => {
  // Get params from the main URL search string
  const combinedParams = new URLSearchParams(window.location.search);

  // Get params from the hash string
  const hash = window.location.hash;
  if (hash.includes("?")) {
    const hashQueryString = hash.substring(hash.indexOf("?"));
    const hashParams = new URLSearchParams(hashQueryString);

    // Add/overwrite with params from the hash
    for (const [key, value] of hashParams.entries()) {
      combinedParams.set(key, value);
    }
  }

  return combinedParams;
};